import { LOAD_MENU, USER_INFO, GET_INSTITUICOES } from './mutation-types'

export default {
  [LOAD_MENU](state, payload) {
    state.data = payload
  },

  [USER_INFO](state, payload) {
    state.info = payload
  },

  [GET_INSTITUICOES](state, payload) {
    state.instituicoes = payload
  }
}
